import { render, staticRenderFns } from "./classroom.vue?vue&type=template&id=1c565933&scoped=true"
import script from "./classroom.vue?vue&type=script&lang=js"
export * from "./classroom.vue?vue&type=script&lang=js"
import style0 from "./classroom.vue?vue&type=style&index=0&id=1c565933&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c565933",
  null
  
)

export default component.exports